import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "p-mx-2" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "m-2 mt-4 mb-4 p-text-center" }
const _hoisted_5 = {
  key: 0,
  class: "p-text-center"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-users" }, null, -1)
const _hoisted_7 = {
  key: 1,
  class: "p-text-center"
}
const _hoisted_8 = { class: "p-mt-2" }
const _hoisted_9 = { class: "table table-bordered table-hover" }
const _hoisted_10 = {
  colspan: "9",
  class: "p-text-right"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("tr", { style: {"background-color":"#004C97","color":"#fff"} }, [
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "SNO"),
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "DATE"),
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "TYPE"),
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "RECEIPT NO"),
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "SOURCE"),
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "DESCRIPTION"),
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "AMOUNT"),
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "PAYMENT"),
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "BALANCE")
], -1)
const _hoisted_12 = { class: "p-p-1" }
const _hoisted_13 = { class: "p-p-1" }
const _hoisted_14 = { class: "p-p-1" }
const _hoisted_15 = { class: "p-p-1" }
const _hoisted_16 = { class: "p-p-1" }
const _hoisted_17 = { class: "p-p-1" }
const _hoisted_18 = { class: "p-p-1" }
const _hoisted_19 = { class: "p-p-1" }
const _hoisted_20 = { class: "p-p-1" }
const _hoisted_21 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-search",
  style: {"font-size":"1.2rem"}
}, null, -1)
const _hoisted_23 = { class: "p-field" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { for: "filterStore" }, "Filter Date", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h5", null, "OR", -1)
const _hoisted_26 = { class: "p-grid" }
const _hoisted_27 = { class: "p-col" }
const _hoisted_28 = { class: "p-field" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { for: "from" }, "Date From", -1)
const _hoisted_30 = { class: "p-col" }
const _hoisted_31 = { class: "p-field" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { for: "to" }, "Date To", -1)
const _hoisted_33 = { class: "p-grid" }
const _hoisted_34 = { class: "p-col" }
const _hoisted_35 = { class: "p-field" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { for: "type" }, "Profile", -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" TITLE : ")
const _hoisted_38 = { class: "pull-right" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Email : ")
const _hoisted_40 = { class: "pull-right" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" Contact : ")
const _hoisted_42 = { class: "pull-right" }
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Account Type : ")
const _hoisted_44 = { class: "pull-right" }
const _hoisted_45 = { class: "p-col" }
const _hoisted_46 = { class: "p-field" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { for: "filterStore" }, "Branch", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Toolbar, null, {
        start: _withCtx(() => [
          _createVNode(_component_Breadcrumb, {
            home: _ctx.home,
            model: _ctx.items,
            class: "p-menuitem-text p-p-1"
          }, null, 8, ["home", "model"])
        ]),
        end: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Button, {
              icon: "pi pi-search",
              class: "p-button-success px-4",
              onClick: _ctx.openDialog
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Button, {
              icon: "pi pi-print",
              class: "p-button-primary px-4",
              onClick: _ctx.openDialog
            }, null, 8, ["onClick"])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h5", null, _toDisplayString(_ctx.storeName) + " Account Statement", 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.resultTitle), 1),
        (_ctx.accountHolder != '')
          ? (_openBlock(), _createElementBlock("h6", _hoisted_5, [
              _hoisted_6,
              _createTextVNode(" " + _toDisplayString(_ctx.accountHolder) + " (" + _toDisplayString(_ctx.accountHolderPhone) + ") ", 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.accountHolder != '')
          ? (_openBlock(), _createElementBlock("h6", _hoisted_7, _toDisplayString(_ctx.storeName), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("table", _hoisted_9, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_10, [
              _createElementVNode("h6", null, " Before Statement Balance : " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.checkForCredit(_ctx.beforeBalance)), 1)
            ])
          ]),
          _hoisted_11,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lists, (l, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: l }, [
              _createElementVNode("td", _hoisted_12, _toDisplayString(i+1), 1),
              _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.formatDateTime(l.date)), 1),
              _createElementVNode("td", _hoisted_14, _toDisplayString(l.type), 1),
              _createElementVNode("td", _hoisted_15, _toDisplayString(l.receiptNo), 1),
              _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.convertToFull(l.type)), 1),
              _createElementVNode("td", _hoisted_17, _toDisplayString(l.description), 1),
              _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.formatAmount(l.amount)), 1),
              _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.formatAmount(l.payment)), 1),
              _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.checkForCredit(l.balance)), 1)
            ]))
          }), 128))
        ])
      ]),
      _createVNode(_component_Dialog, {
        visible: _ctx.productDialog,
        "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.productDialog) = $event)),
        style: { width: '50vw' },
        maximizable: true,
        position: "top",
        class: "p-fluid"
      }, {
        header: _withCtx(() => [
          _createElementVNode("h5", _hoisted_21, [
            _hoisted_22,
            _createTextVNode(" " + _toDisplayString(_ctx.dialogTitle), 1)
          ])
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            type: "submit",
            label: "Search",
            icon: "pi pi-search",
            class: "p-button-primary",
            onClick: _ctx.loadList
          }, null, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.searchFilters.filterType,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchFilters.filterType) = $event)),
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearForFilters())),
              options: _ctx.filterDates,
              filter: true,
              optionLabel: "key",
              optionValue: "value"
            }, null, 8, ["modelValue", "options"])
          ]),
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  id: "from",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchFilters.date1) = $event)),
                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args))),
                  class: "form-control"
                }, null, 544), [
                  [_vModelText, _ctx.searchFilters.date1]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  id: "to",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchFilters.date2) = $event)),
                  onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args))),
                  class: "form-control"
                }, null, 544), [
                  [_vModelText, _ctx.searchFilters.date2]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _createVNode(_component_AutoComplete, {
                  delay: 1000,
                  minLength: 3,
                  onItemSelect: _cache[6] || (_cache[6] = ($event: any) => (_ctx.saveProfile($event))),
                  scrollHeight: "500px",
                  modelValue: _ctx.searchFilters.customerName,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchFilters.customerName) = $event)),
                  suggestions: _ctx.profilerList,
                  placeholder: "Search Profile",
                  onComplete: _cache[8] || (_cache[8] = ($event: any) => (_ctx.searchProfiler($event))),
                  dropdown: false
                }, {
                  item: _withCtx((slotProps) => [
                    _createElementVNode("div", null, [
                      _hoisted_37,
                      _createElementVNode("b", _hoisted_38, _toDisplayString(slotProps.item.account_title.toUpperCase()), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_39,
                      _createElementVNode("span", _hoisted_40, _toDisplayString(slotProps.item.email_address), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_41,
                      _createElementVNode("span", _hoisted_42, _toDisplayString(slotProps.item.contact_no), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_43,
                      _createElementVNode("span", _hoisted_44, _toDisplayString(slotProps.item.account_type), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "suggestions"])
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.searchFilters.storeID,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.searchFilters.storeID) = $event)),
                  options: _ctx.filterBranch,
                  filter: true,
                  optionLabel: "name",
                  optionValue: "id"
                }, null, 8, ["modelValue", "options"])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ]))
}